import http from "../http_v2";

import subject from "./subject.js"; // 内容专题API

import article from "./article.js"; // 文章
import doc from "./doc.js"; // 资料
import video from "./video.js"; // 视频
import poster from "./poster.js"; // 海报
import question from "./question.js"; // 调查问卷
import product from "./product.js"; // 产品
import solution from "./solution.js"; // 解决方案
import cases from "./case.js"; // 客户案例
import wall from "./wall.js"; // 客户墙
import questionnaire from "./questionnaire.js"; //问卷调查
import featured from "./featured.js";

export default {
  subject,
  article,
  doc,
  video,
  poster,
  question,
  product,
  solution,
  cases,
  wall,
  questionnaire,
  featured,
  form: {
    list: (data) => {
      // 获取表单列表
      return http.post("formbuilder/applyform/page", data);
    },
    info: (id) => {
      // 根据表单ID获取表单详情
      return http.get("formbuilder/applyform/get/" + id);
    },
  },
  activity: {
    list: (data) => {
      // 获取活动列表
      return http.post("activityservice/activitysearch/page", data);
    },
  },
  data: {
    list: (data) => {
      // 获取资料文件列表
      return http.get("content-service/doc_article/page", data);
    },
    info: (id) => {
      // 根据资料ID获取资料详情
      return http.get("content-service/doc_article/" + id);
    },
  },
  // 内容组合
  group: {
    info: (params) => {
      return http.get("websitecenter/content/netapi/list", params);
    },
    save: (params) => {
      return http.post("websitecenter/content/save", params);
    },
  },
  // 内容中心自定义字段
  field: {
    list: (params) => {
      return http.get("content-service/field/list", params);
    },
    save: (params) => {
      return axios.post("content-service/field/save", params);
    },
    del: (params) => {
      return axios.get("content-service/field/delete", params);
    },
  },
  // 一键生成素材
  reptile(params) {
    return http.post("content-service/cnt_article/reptile", params);
  },
  // 内容追踪
  tracking: {
    visitList(params) {
      return http.get("content-service/cnt_article_ops/visited_list", params);
    },
    shareList(params) {
      return http.get("content-service/cnt_article_ops/forward_list", params);
    },
  },
};
